module.exports = __webpack_public_path__ + "static/media/logstash.eeea0517.svg";